/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

const checkLocalStorage = () => {
  try {
    return "localStorage" in window && window.localStorage != null;
  } catch (e) {
    return false;
  }
};

export const polyfillLocalStorage = () => {
  if (!checkLocalStorage()) {
    function Storage() {}

    Storage.prototype.setItem = function (id: string | number, val: any) {
      this._data[id] = JSON.stringify(val);
      this._save();
    };
    Storage.prototype.getItem = function (id: string | number) {
      return this._data.hasOwnProperty(id) ? this._data[id] : null;
    };
    Storage.prototype.removeItem = function (id: string | number) {
      delete this._data[id];
      this._save();
      return this._data[id];
    };
    Storage.prototype.clear = function () {
      const self = this;
      Object.keys(this._data).map(function (key) {
        self._data.removeItem(key);
      });
      this._save();
    };

    Storage.prototype._getData = function () {
      try {
        return JSON.parse(
          document.cookie.replace(
            /(?:(?:^|.*;\s*)localStorage\s*\=\s*([^;]*).*$)|^.*$/,
            "$1",
          ) || "{}",
        );
      } catch (e) {
        return new Object();
      }
    };

    Storage.prototype.rehydrate = function () {
      this._data = this._getData();
    };

    Storage.prototype._save = function () {
      document.cookie =
        "localStorage=" +
        JSON.stringify(this._data) +
        "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/";
    };

    //@ts-ignore
    const storage = new Storage();
    storage.rehydrate();

    try {
      try {
        window.localStorage = storage;
      } catch (e) {
        Object.defineProperty(window, "localStorage", {
          value: storage,
        });
      }
    } catch (e) {
      // couldn't set the localStorage polyfill
      console.log("localStorage polyfill not set", e);
    }
  }
};
